import { HttpMethod, HttpOption } from '@/utils/http-client'
import { PasswordRequest, VersionInfoRequest } from '@/api/model/user'
import { ServerConfig } from '@/config/server-config'
import { AUTH_REQUEST_TIMEOUT } from '@/utils/auth-request'

export class UserAPIConstant {
    login = (): HttpOption => ({
        url: `/v1/login-info`,
        method: HttpMethod.POST,
        timeout: AUTH_REQUEST_TIMEOUT
    })

    logout = (): HttpOption => ({
        baseURL: ServerConfig.DinoUrl,
        url: '/logout',
        method: HttpMethod.POST
    })

    updatePassword = (data: PasswordRequest): HttpOption => ({
        baseURL: ServerConfig.DinoUrl,
        url: '/v1/mgt/user/change-password',
        method: HttpMethod.POST,
        data
    })

    queryVersionInfo = (data: VersionInfoRequest): HttpOption => ({
        baseURL: ServerConfig.DinoUrl,
        url: '/v1/rpc/release-version/query-all',
        method: HttpMethod.POST,
        data
    })
}
